<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Arrow.24"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Path_8213"
      data-name="Path 8213"
      d="M14,8l-4,4,4,4"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path id="Path_8214" data-name="Path 8214" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
